(ns app.domain.verdict.common-util
  "Simple utilities for frontend and backend (pdf) verdict rendering."
  (:require #?(:clj [core.util.edn :as edn])
            [app.domain.business.model :as business-model]
            [app.domain.form.model :as form-model]
            [app.domain.party.model :as party-model]
            [app.domain.util :as du]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [schema.core :as s]))


(defn content [section]
  #?(:clj  (-> (:verdict.section/content section) edn/decode)
     :cljs (:verdict.section/content section)))


(defn affiliation
  "First name Last name / Firm. Blanks/nils are omitted."
  [party lang-or-langs]
  (if-some [business (:party/business party)]
    (business-model/format-name business lang-or-langs)
    (let [full-name (party-model/user-party-full-name party)
          company   (party-model/get-user-party-user-key party :user/corporation-or-partnership)]
      (->> [full-name company]
           (remove str/blank?)
           (map str/trim)
           (str/join " / ")))))


(s/defn munizip
  "Municipality, Province  Zip. Blanks/nils are omitted."
  [ctx :- i18n-model/Ctx, party]
  (let [muni     (party-model/get-user-key ctx party :user/municipality)
        province (party-model/get-user-key ctx party :user/province)
        zip      (party-model/get-user-key ctx party :user/postal-code)
        mz       (->> [muni province]
                      (remove str/blank?)
                      (str/join ", "))]
    (->> [mz (str/trim (or zip ""))]
         (remove str/blank?)
         (str/join "  "))))


(defn get-permit-description-form-field
  "Returns the `Description of Permit` form field"
  [verdict]
  (form-model/get-form-field (:entity/parent verdict) :description-of-permit))


(defn get-permit-description-form-field-value [verdict]
  (-> (get-permit-description-form-field verdict)
      form-model/decode-value
      str
      str/trim))


(defn get-permit-description-value
  "Note that there are two different entities that can have value for permit description"
  [verdict]
  (let [permit-description-form-field-value (get-permit-description-form-field-value verdict)]
    (if (str/blank? permit-description-form-field-value)
      (->> verdict
           (du/find-descendant #(-> % :verdict.section/id (= :description-of-permit)))
           content
           str
           str/trim)
      permit-description-form-field-value)))
